<template>
  <div class="cablePurchaseDetail">
    <template>
      <div class="sousuo">
        <div class="sousuo-nr">
          <div class="vm-search">
            <vm-search label="订单日期">
              <div class="block">
                <el-date-picker
                    v-model="filter.orderTimeStart"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 190px"
                    placeholder="选择开始日期"/>
              </div>
            </vm-search>
            <vm-search label="至">
              <div class="block">
                <el-date-picker
                    v-model="filter.orderTimeEnd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 190px"
                    placeholder="选择结束日期"/>
              </div>
            </vm-search>
          </div>
        </div>
      </div>
      <div class="ad-search-btn" style="text-align: right;margin: 1% 0;">
        <el-button
            :loading="loading"
            type="primary"
            size="mini"
            style="height: 26px;padding: 0 10px"
            @click="handleSearchClick">
          查询
        </el-button>
        <el-button
            plain
            type="primary"
            size="mini"
            style="height: 26px;padding: 0 10px"
            @click="handleClearClick">
          重置
        </el-button>
      </div>
    </template>
    <el-table
        v-loading="loading"
        :data="tableData"
        height="60vh"
        style="width: 100%">
      <el-table-column fixed="left" type="expand">
        <template slot-scope="props">
          <el-form>
            <el-table :data="props.row.salesForecastVOS" style="width: 100%;margin: 0 auto">
              <el-table-column align="center" label="物料类型" prop="materialType"/>
              <el-table-column align="center" label="数量" prop="numberOf"/>
              <el-table-column align="center" label="后半月" prop="halfMonthCount">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.halfMonthCount" placeholder="请输入"/>
                </template>
              </el-table-column>
              <el-table-column align="center" label="后一月" prop="nextMonth">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.nextMonth" placeholder="请输入"/>
                </template>
              </el-table-column>
              <el-table-column align="center" label="后二月" prop="nextFebruary">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.nextFebruary" placeholder="请输入"/>
                </template>
              </el-table-column>
            </el-table>
            <el-button
                plain
                type="primary"
                size="mini"
                style="float: right; "
                @click="onSubmit(props.row)">
              提交
            </el-button>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="customerName" label="客户名称"/>
    </el-table>
  </div>
</template>

<script>
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import auth from "@/util/loginUtil";

  export default {
    name: "SalesForecast",
    components: {VmSearch},

    data() {
      return {
        tableData: [],
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        loading: false,
        authName: auth.getUserName(),
        planStartDate: "",
        planEndDate: "",
        constant,
        currentUserId: auth.getUserId(),
        filter: {
          orderTimeStart: "",
          orderTimeEnd: "",
        },
      };
    },

    mounted() {
      // this.$refs.vmTable.getList(1);
    },

    methods: {
      getList() {
        this.loading = true;
        this.$http.get("basic", "salesForecasts/getSalesOrderList", this.filter).then(res => {
          console.log(res);
          this.loading = false;
          this.tableData = res;
        }).catch(() => {
          this.loading = false;
          this.$message.error("获取失败");
        });
      },
      handleSearchClick() {
        this.getList(1);
      },
      handleClearClick() {
        this.filter.orderTimeStart = "";
        this.filter.orderTimeEnd = "";
      },
      onSubmit(row) {
        console.log(row);
        let salesForecastTotalVO = {
          customerName: row.customerName,
          salesForecastTotalDetailVOS: row.salesForecastVOS,
        };
        this.$http.post("basic", "salesForecastTotals", salesForecastTotalVO).then(res => {
          console.log(res);
          this.loading = false;
          this.$message.success("提交成功");
        }).catch(() => {
          this.loading = false;
          this.$message.error("提交失败");
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.cablePurchaseDetail {
  position: relative;

  .el-pagination {
    text-align: right;
  }

  .toolbar-btn {
    margin-bottom: 13px;
    display: flex;
    flex-direction: row;
    -webkit-align-content: center;
    align-items: center;
  }

  .sousuo {
    width: 100%;
    background: #f4f7fa;
    margin-bottom: 1%;
    border: 1px solid #EBEEF5;

    .sousuo-nr {
      padding: 8px 133px 8px 10px;
    }

    .ad-search-btn {
      text-align: right;
      margin: 1% 2%;
    }

  }
}
</style>